import { render, staticRenderFns } from "./AudioSearchApproved.vue?vue&type=template&id=ee00a964"
import script from "./AudioSearchApproved.vue?vue&type=script&lang=js"
export * from "./AudioSearchApproved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports